<script>
  import { Link } from "svelte-routing";
  import { _ as t } from "svelte-i18n";
  import { Ribbon } from "t2c-components";

  export let link = null;
  export let document;

  const shorten = (text, max) =>
    text && text.length > max
      ? `${text.slice(0, max).split(" ").slice(0, -1).join(" ")}...`
      : text;
</script>

<div
  class={`tile ${document.thumbnailSource ? "thumb" : ""}`}
  style={document.thumbnailSource
    ? `background-image: url("${document.thumbnailSource}");`
    : ""}
>
  {#if document.clientId}
    <Ribbon text={$t("document.clientDocument")} />
  {/if}
  {#if link}
    <Link getProps={() => ({ class: "tile-link" })} to={link}>
      <div class="container">
        <div class="title">
          <h2>{document.title}</h2>
        </div>
        <div>
          <p>
            {document.description
              ? shorten(document.description, 150)
              : $t("content.noDescription")}
          </p>
        </div>
      </div>
    </Link>
  {:else}
    <span class="tile-link">
      <div class="container">
        <div class="title">
          <h2>{document.title}</h2>
        </div>
        <div>
          <p>
            {document.description
              ? shorten(document.description, 150)
              : $t("content.noDescription")}
          </p>
        </div>
      </div>
    </span>
  {/if}
</div>

<style>
  :global(.tile-link) {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  .tile {
    position: relative;
    display: block;
    height: 0;
    padding-bottom: 100%;
    transition: all 0.2s ease-in-out;
  }

  .thumb::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--seppia-color);
    opacity: 1;
    z-index: 1;
    mix-blend-mode: color;
    /* mix-blend-mode: hue; */
    mix-blend-mode: hard-light;
  }

  .container:hover {
    color: white;
    background-color: #40798c;
    transition: all 0.2s ease-in-out;
  }

  .container:hover * {
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 0.2s ease-in-out;
  }

  .container {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #1f363d;
    cursor: pointer;
  }

  .container.loading {
    border: 1px dashed #1f363d;
    cursor: auto;
  }

  .container.loading:hover {
    color: #1f363d;
    background-color: white;
    transition: all 0.2s ease-in-out;
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 12px;
    height: 50%;
    flex: 0 0 auto;
  }

  h2 {
    font-weight: 300;
    font-size: 22px;
    /* word-wrap: break-word; */
    word-break: break-all;
    line-height: 26px;
    background-color: rgba(255, 255, 255, 0.5);
  }

  p {
    font-size: 12px;
    font-weight: 300;
    text-align: center;
    padding: 5px 12px;
    background-color: rgba(255, 255, 255, 0.5);
  }
</style>
